export default "__VITE_ASSET__BDXXW4_Y__"